'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const orderBy = require('lodash/orderBy');
const filter = require('lodash/filter');
const uuid = require('uuid');
const Moment = require('moment')
import { withRouter } from 'react-router-dom'
import { Row } from 'react-bootstrap';

const Globals = require('../../../app/globals');
const Strings = require('../../../app/shared/Strings');
const ProjectActions = require('../actions/ProjectActions');
const ActivityActions = require('../actions/ActivityActions');
const ShortCourseActions = require('../actions/ShortCourseActions');
const TemplateStore = require('../stores/template_store_reflux');
const ChannelStore = require('../stores/channel_store_reflux');
const ProjectStore = require('../stores/ProjectStore');
const ShortCourseStore = require('../stores/ShortCourseStore');
const ScrollUtil = require('../util/ScrollUtil');
const LocalStorage = require('../util/localStorage');
const ServerRequest = require('../actions/request');
const PermissionsUtil = require('../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../app/shared/FeatureUtil');
const FilterUtil = require('../util/FilterUtil');
import Navigator from '../Navigator';
import MainNav from './DashboardNew/Menu/MainNav';
import SubNav from './nav/SubNav';
import { ProjectBreadCrumbs } from './nav/NavBreadCrumbs';
import BackButton from './nav/BackButton';
import SideNav from './nav/SideNav';
import ErrorBox from './common/ErrorBox';
import FilterBox from './common/FilterBox';
import ActivityListing from './project/ActivityListing';
import ShortCourseListing from './project/ShortCourseListing';
import SingleInputModal from './modal/SingleInputModal2';
import CopyProjectModal from './modal/CopyProjectModal';
import TransferProjectModal from './modal/TransferProjectModal';
import StackImportModal from './modal/StackImportModal';
import StackImportShortCourseModal from './modal/StackImportShortCourseModal';
import StackImportProjectModal from './modal/StackImportProjectModal';
import ManageProjectTagsModal from './modal/ManageProjectTagsModal';
import LoadingMainContent from './loading/LoadingMainContent';
import WithProjectActivities from './DataHOCs/WithProjectActivities';
import WithProjectShortCourses from './DataHOCs/WithProjectShortCourses';
import WithOrganizationIntegrationTags from './DataHOCs/WithOrganizationIntegrationTags';
import ConfirmPhraseModal from './modal/ConfirmPhraseModal';
import ProjectDescriptionEditor from './project/ProjectDescriptionEditor';

const propTypes = {
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.array }).isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            channel: PropTypes.string.isRequired,
            projectID: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

const defaultProps = {};

const SORT_ALPHA = "SORT_ALPHA";
const SORT_TEMPLATE = "SORT_TEMPLATE";
const SORT_CREATED = "SORT_CREATED";
const SORT_MODIFIED = "SORT_MODIFIED";

class ProjectView extends React.Component {
    constructor(props) {
        super(props);
        const projectID = parseInt(this.props.match.params.projectID, 10);
        const storedSort = LocalStorage.getViewSettingPropForViewSubset("project", projectID, "sort");
        this.state = {
            projectID: projectID,
            templateStoreState: TemplateStore.getState(),
            channelStoreState: ChannelStore.getStateChannel(this.props.match.params.channel),
            projectStoreState: ProjectStore.getStateProject(projectID),
            nameFilter: '',
            tagFilter: '',
            sort: {
                type: storedSort ? storedSort.type : SORT_ALPHA,
                asc: storedSort ? storedSort.asc : true
            },
            modalState: {
                createCourse: false,
                importCourse: false,
                renameProject: false,
                confirmArchive: false,
                addUserProject: false,
                copyProject: false,
                transferProject: false,
                stackImport: false,
                projectTags: false,
            },
            copyProjectActionId: null,
            copyProjectError: null,
            transferProjectActionId: null,
            transferProjectError: null,
            renameProjectActionId: null,
            // renameProjectError: null,
            archiveProjectActionId: null,
            archiveProjectError: null,
            createShortCourseActionId: null,
            createCourseError: null,
        };

        this.getImportStacks = this.getImportStacks.bind(this);
        this.renameProjectHandler = this.renameProjectHandler.bind(this);
        this.copyProjHandler = this.copyProjHandler.bind(this);
        this.transferProjectHandler = this.transferProjectHandler.bind(this);
        this.archiveProjectHandler = this.archiveProjectHandler.bind(this);
        this.createCourseHandler = this.createCourseHandler.bind(this);
        this.gotoProjectCollabs = this.gotoProjectCollabs.bind(this);
        this.backHandler = this.backHandler.bind(this);
        this.gotoProjectAnalytics = this.gotoProjectAnalytics.bind(this);
        this.sort = this.sort.bind(this);
        this.onNameFilterChange = this.onNameFilterChange.bind(this);
        this.onTagFilterChange = this.onTagFilterChange.bind(this);
        this.createNewActivity = this.createNewActivity.bind(this);
        this._showModal = this._showModal.bind(this);
        this._hideModal = this._hideModal.bind(this);
        this.unsubscribes = [
            TemplateStore.listen(this.onTemplateStoreChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
            ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.getImportStacks();

        if (
            this.state.templateStoreState.initialized
            && !!this.props.activityStoreState.initialized
        ) { // component is rendering projects
            ScrollUtil.scrollToUsingHash();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onTemplateStoreChange(state) {
        this.setState({ templateStoreState: state });
    }

    onChannelStoreChange(state) {
        this.setState({ channelStoreState: ChannelStore.getStateChannel(this.props.match.params.channel) })
    }

    onProjectStoreChange(state) {
        const projectStoreState = ProjectStore.getStateProject(this.state.projectID);
        if (state.initialized && !projectStoreState.project) {
            this.backHandler();
            return;
        }

        let newState = { projectStoreState: projectStoreState };
        if (this.state.copyProjectActionId === state.action.id) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    copyProjectActionId: null,
                    copyProjectError: state.action.error,
                }
            }
            else {
                newState = {
                    ...newState,
                    copyProjectActionId: null,
                    copyProjectError: null,
                    modalState: { ...this.state.modalState, copyProject: false },
                }
            }
        }
        else if (this.state.transferProjectActionId === state.action.id) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    transferProjectActionId: null,
                    transferProjectError: state.action.error,
                }
            }
            else {
                newState = {
                    ...newState,
                    transferProjectActionId: null,
                    transferProjectError: null,
                    modalState: { ...this.state.modalState, transferProject: false },
                }
            }
        }
        else if (this.state.renameProjectActionId === state.action.id) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    // renameProjectActionId: null,
                    renameProjectError: state.action.error,
                }
            }
            else {
                newState = {
                    ...newState,
                    renameProjectActionId: null,
                    renameProjectError: null,
                    modalState: { ...this.state.modalState, renameProject: false },
                }
            }
        }
        else if (this.state.archiveProjectActionId === state.action.id) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    archiveProjectActionId: null,
                    archiveProjectError: state.action.error,
                }
            }
            else {
                this.backHandler();
                return;
            }
        }

        this.setState(newState);
    }

    onShortCourseStoreChange(state) {
        let newState = {};
        let transitionTo;
        if (state.action.id === this.state.createShortCourseActionId) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    createCourseError: state.action.error,
                };
            }
            else {
                newState = {
                    ...newState,
                    createShortCourseActionId: null,
                    createCourseError: null,
                    modalState: { ...this.state.modalState, createCourse: false },
                };
                transitionTo = `/project/${this.props.match.params.channel}/${this.props.match.params.projectID}/short_course/${state.action.newShortCourse.id}`;
            }

            this.setState(newState, () => {
                if (transitionTo) {
                    this.props.history.push(transitionTo);
                }
            });
        }
    }

    getImportStacks() {
        ServerRequest.makeRequest('/authoring/import_stacks', 'POST')
            .then((res) => {
                this.setState({ importStacks: res });
            })
            .catch((err) => {
                this.setState({ importStacks: [] });
            });
    }

    renameProjectHandler(newName) {
        const renameProjectActionId = uuid.v4();
        this.setState({ renameProjectActionId: renameProjectActionId }, () => {        
            ProjectActions.renameProject(
                renameProjectActionId,
                {
                    projectID: this.state.projectID,
                    name: newName
                }
            );
        });
    }

    copyProjHandler(name, targetChannel, targetFolder) {
        if (!targetChannel && !targetFolder) {
            console.error(`ProjectView.copyProjHandler() missing target`);
            return;
        }

        const copyProjectActionId = uuid.v4();
        this.setState({ copyProjectActionId: copyProjectActionId }, () => {
            ProjectActions.copyProject(copyProjectActionId, {
                projectId: this.state.projectID,
                channelId: targetChannel,
                folderId: targetFolder,
                name: name
            });
        });
    }

    transferProjectHandler(targetFolder) {
        const transferProjectActionId = uuid.v4();
        this.setState({ transferProjectActionId: transferProjectActionId }, () => {
            ProjectActions.transferProject(transferProjectActionId, {
                projectId: this.state.projectID,
                folderId: targetFolder,
            });
        });
    }

    archiveProjectHandler() {
        const archiveProjectActionId = uuid.v4();
        this.setState({ archiveProjectActionId: archiveProjectActionId }, () => {
            ProjectActions.archiveProject(
                archiveProjectActionId,
                { projectID: this.state.projectID }
            );

        });
    }

    createCourseHandler(title) {
        const createShortCourseActionId = uuid.v4();
        this.setState({ createShortCourseActionId: createShortCourseActionId }, () => {        
            ShortCourseActions.createShortCourse(
                createShortCourseActionId,
                {
                    projectId: this.props.projectId,
                    channelId: this.props.channelId,
                    title: title,
                }
            );
        });
    }

    gotoProjectCollabs() {
        this.props.history.push(`/project/${this.props.match.params.channel}/${this.props.match.params.projectID}/editAccess`);
    }

    backHandler() {
        const project = this.state.projectStoreState.project || this.state.projectStoreState.shortCourseProject;
        let options;
        if (!!project) {
            options = { queryObj: { cType: project.content_type }, addLeadingQuestionMark: true };
        }

        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.match.params.channel, null, options);
    }

    gotoProjectAnalytics() {
        this.props.history.push(`/project/${this.props.match.params.channel}/${this.props.match.params.projectID}/analytics`);
    }

    sort(type) {
        let sortAsc;
        if (this.state.sort.type === type) {
            sortAsc = !this.state.sort.asc;
        }
        else if (type === SORT_CREATED || type === SORT_MODIFIED) { // sort latest -> oldest by default
            sortAsc = false;
        }
        else {
            sortAsc = true;
        }

        LocalStorage.setViewSettingPropForViewSubset('project', this.state.projectID, 'sort', { type: type, asc: sortAsc });

        this.setState({
            sort: {
                type: type,
                asc: sortAsc
            }
        });
    }

    onNameFilterChange(e) {
        this.setState({ nameFilter: e.target.value });
    }

    onTagFilterChange(e) {
        this.setState({ tagFilter: e.target.value });
    }

    createNewActivity() {
        this.props.history.push(`/project/${this.props.match.params.channel}/${this.props.match.params.projectID}/create-activity`);
    }

    _showModal(modalName) { // helper in moving away from mixins (ModalMixin)
        this.setState({ modalState: { ...this.state.modalState, [modalName]: true }});
    }

    _hideModal(modalName) { // helper in moving away from mixins (ModalMixin)
        this.setState({ modalState: { ...this.state.modalState, [modalName]: false }});
    }

    render() {
        const self = this;
        function actTitle(act) {
            return act.meta_data.title.toLowerCase();
        }

        function actTemplate(act) {
            const actTemplate = find(self.state.templateStoreState.templates, tmpl => tmpl.module_id === act.module_id);
            return actTemplate ? actTemplate.name : act.product;
        }

        function actCreated(act) {
            return act.created_at ? Moment(act.created_at).valueOf() : 0;
        }

        function actModified(act) {
            let saveTime;

            if (!!act.modified) {
                saveTime = Moment(act.modified).valueOf();
            }
            else {
                saveTime = Moment(act.created_at).valueOf();
            }

            return saveTime;
        }

        function scTitle(sc) {
            return sc.title.toLowerCase();
        }

        function scCreated(sc) {
            return sc.created_at ? Moment(sc.created_at).valueOf() : 0;
        }

        function scModified(sc) {
            let modifiedAt;
            if (!!sc.modified_at) {
                modifiedAt = Moment(sc.modified_at).valueOf();
            }
            else {
                modifiedAt = Moment(sc.created_at).valueOf();
            }

            return modifiedAt;
        }

        if (
            !this.state.projectStoreState.initialized
            || !this.state.channelStoreState.initialized
        ) {
            return null;
        }

        const project = this.state.projectStoreState.project || this.state.projectStoreState.shortCourseProject;
        const projectName = project.name || '';
        const userProjectPermissions = project.user_permissions;
        const channel = this.state.channelStoreState.channel;
        const channelPermissions = channel.channel_permissions;
        const userChannelPermissions = channel.user_permissions;
        const showTagFilter = FeatureUtil.hasIntegrationTags(channelPermissions) && PermissionsUtil.canManageActivityTags(userChannelPermissions, userProjectPermissions) && project.content_type === Globals.content_type.ACTIVITY;

        let numFilteredNodes = 0;
        let contentNodes;
        let actions = [];
        let strNodeSingular;
        let strNodePlural;
        let foldersFlat;
        let homeNavOptions = {};
        if (project.content_type === Globals.content_type.ACTIVITY) {
            strNodeSingular = Strings['en'].activity.ACTIVITY;
            strNodePlural = Strings['en'].activity.ACTIVITIES;
            foldersFlat = this.state.channelStoreState.foldersFlat;
            const canCreateActivity = PermissionsUtil.canCreateNewActivity(userChannelPermissions, userProjectPermissions);
            homeNavOptions = {};
            if (
                this.state.templateStoreState.initialized
                && !!this.props.activityStoreState.initialized
            ) {
                const tagsWithMatchingDesc = FilterUtil.getTagsWithMatchingDescObj(this.state.tagFilter, this.props.orgIntegrationTags);
                const filteredActs = this.props.activityStoreState.activities.filter(act => FilterUtil.activityMatchesFilter(this.state.nameFilter, this.state.tagFilter, tagsWithMatchingDesc, act));
                const order = this.state.sort.asc ? "asc" : "desc";
                numFilteredNodes = filteredActs.length;
                let sortedActs;

                if (filteredActs.length > 0) {
                    switch (this.state.sort.type) {
                        case SORT_ALPHA: {
                            sortedActs = orderBy(filteredActs, (act) => {
                                return [actTitle(act), actTemplate(act).toLowerCase()];
                            }, order);
                            break;
                        }

                        case SORT_TEMPLATE: {
                            sortedActs = orderBy(filteredActs, (act) => {
                                return [actTemplate(act).toLowerCase(), actTitle(act)];
                            }, order);
                            break;
                        }

                        case SORT_CREATED: {
                            sortedActs = orderBy(filteredActs, (act) => {
                                return [actCreated(act), actTitle(act)];
                            }, order);
                            break;
                        }

                        case SORT_MODIFIED: {
                            sortedActs = orderBy(filteredActs, (act) => {
                                return [actModified(act), actTitle(act)];
                            }, order);
                            break;
                        }

                        default: {
                            sortedActs = filteredActs;
                            break;
                        }
                    }

                    contentNodes = sortedActs.map((activity) => {
                        const actTemplate = find(this.state.templateStoreState.templates, tmpl => tmpl.product === activity.product);
                        return (
                            <ActivityListing
                                key={activity.activity_id}
                                activity={activity}
                                template={actTemplate}
                                channel={this.props.match.params.channel}
                                projectId={this.props.match.params.projectID}
                            />
                        );
                    });
                }
                else if (!!this.state.nameFilter || !!this.state.tagFilter) {
                    contentNodes = (
                        <li className="listing empty-listing">
                            <h2>{Strings['en'].project.NO_ACTIVITIES_FOR_FILTER}</h2>
                        </li>
                    );
                }
                else {
                    contentNodes = (
                        <li className="listing empty-listing">
                            {canCreateActivity ?
                                <h2>{Strings['en'].project.NO_ACTIVITIES} <a href='#' onClick={this.createNewActivity}>{Strings['en'].project.TRY_ADDING_ACT}</a></h2>
                                :
                                <h2>{Strings['en'].project.NO_ACTIVITIES}</h2>
                            }
                        </li>
                    );
                }
            }
            else {
                contentNodes = <LoadingMainContent />;
            }

            if (canCreateActivity) {
                actions.push({
                    value: Strings['en'].project.actions.NEW_ACT,
                    handler: this.createNewActivity,
                    group:0,
                    //bgColor: "#DCEDC2",
                    icon: `${GlobalConfig.StaticUrl}/img/AddAction_sm.svg`,
                    iconStyle: { width: '24px' },
                    subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                });

                if (this.state.importStacks && this.state.importStacks.length) {
                    actions.push({
                        value: Strings['en'].project.actions.STACK_IMPORT_ACT,
                        handler: this._showModal.bind(this, "stackImport"),
                        group:0,
                        //bgColor: "#DCEDC2",
                        icon: `${GlobalConfig.StaticUrl}/img/AddAction_sm.svg`,
                        iconStyle: { width: '24px' },
                        subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                    });
                    
                    actions.push({
                        value: Strings['en'].project.actions.STACK_IMPORT_PROJECT,
                        handler: this._showModal.bind(this, "stackProjectImport"),
                        group:0,
                        //bgColor: "#DCEDC2",
                        icon: `${GlobalConfig.StaticUrl}/img/AddAction_sm.svg`,
                        iconStyle: { width: '24px' },
                        subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                    });
                }
            }
        }
        else if (project.content_type === Globals.content_type.COURSE) {
            const canCreateNewShortCourse = PermissionsUtil.canCreateNewShortCourse(userChannelPermissions, userProjectPermissions);
            strNodeSingular = Strings['en'].short_course.SHORT_COURSE;
            strNodePlural = Strings['en'].short_course.SHORT_COURSES;
            foldersFlat = this.state.channelStoreState.shortCourseFoldersFlat;
            homeNavOptions = { queryObj: { cType: Globals.content_type.COURSE }, addLeadingQuestionMark: true };
            if (!!this.props.shortCourseStoreState.initialized) {
                const tagsWithMatchingDesc = FilterUtil.getTagsWithMatchingDescObj(this.state.tagFilter, this.props.orgIntegrationTags);
                const filteredShortCourses = Object.values(this.props.shortCourseStoreState.shortCourses).filter(sc => FilterUtil.shortCourseMatchesFilter(this.state.nameFilter, this.state.tagFilter, tagsWithMatchingDesc, sc));
                const order = this.state.sort.asc ? "asc" : "desc";
                numFilteredNodes = filteredShortCourses.length;
                let sortedShortCourses;

                if (canCreateNewShortCourse) {
                    actions.push({
                        value: Strings['en'].project.actions.NEW_SC,
                        handler: this._showModal.bind(this, 'createCourse'),
                        group:0,
                        //bgColor: "#DCEDC2",
                        icon: `${GlobalConfig.StaticUrl}/img/AddAction_sm.svg`,
                        iconStyle: { width: '24px' },
                        subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                    });
                    
                    if (this.state.importStacks && this.state.importStacks.length) {
                        actions.push({
                            value: Strings['en'].project.actions.STACK_IMPORT_COURSE,
                            handler: this._showModal.bind(this, "importCourse"),
                            group:0,
                            //bgColor: "#DCEDC2",
                            icon: `${GlobalConfig.StaticUrl}/img/AddAction_sm.svg`,
                            iconStyle: { width: '24px' },
                            subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                        });
                    }
                    
                }

                if (filteredShortCourses.length > 0) {
                    switch (this.state.sort.type) {
                        case SORT_ALPHA: {
                            sortedShortCourses = orderBy(filteredShortCourses, (sc) => {
                                return [scTitle(sc)];
                            }, order);
                            break;
                        }

                        case SORT_CREATED: {
                            sortedShortCourses = orderBy(filteredShortCourses, (sc) => {
                                return [scCreated(sc), scTitle(sc)];
                            }, order);
                            break;
                        }

                        case SORT_MODIFIED: {
                            sortedShortCourses = orderBy(filteredShortCourses, (sc) => {
                                return [scModified(sc), scTitle(sc)];
                            }, order);
                            break;
                        }

                        default: {
                            sortedShortCourses = filteredShortCourses;
                            break;
                        }
                    }

                    contentNodes = sortedShortCourses.map((sc) => {
                        return (
                            <ShortCourseListing
                                key={sc.id}
                                shortCourse={sc}
                                channelId={this.props.channelId}
                                projectId={this.props.projectId}
                            />
                        );
                    });
                }
                else if (!!this.state.nameFilter || !!this.state.tagFilter) {
                    contentNodes = (
                        <li className="listing empty-listing">
                            <h2>{Strings['en'].project.NO_SHORT_COURSES_FOR_FILTER}</h2>
                        </li>
                    );
                }
                else {
                    contentNodes = (
                        <li className="listing empty-listing">
                            {canCreateNewShortCourse ?
                                <h2>{Strings['en'].project.NO_SHORT_COURSES} <a href='#' onClick={this._showModal.bind(this, 'createCourse')}>{Strings['en'].project.TRY_ADDING_SC}</a></h2>
                                :
                                <h2>{Strings['en'].project.NO_SHORT_COURSES}</h2>
                            }
                        </li>
                    );
                }
            }
            else {
                contentNodes = <LoadingMainContent />;
            }
        }


        actions = actions.concat([
            {
                label: <span>{Strings['en'].project.actions.SORT_ALPHA}</span>,
                value: Strings['en'].project.actions.SORT_ALPHA,
                handler: this.sort.bind(this, SORT_ALPHA),
                group:0,
                radioActive: this.state.sort.type === SORT_ALPHA,
                //bgColor: this.state.sort.type === SORT_ALPHA ? "#dddddd": "#cccccc",
                icon: `${GlobalConfig.StaticUrl}/img/SortAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            }
        ]);
        if (project.content_type === Globals.content_type.ACTIVITY) {
            actions.push(
                {
                    label: <span>{Strings['en'].project.actions.SORT_TEMPLATE}</span>,
                    value: Strings['en'].project.actions.SORT_TEMPLATE,
                    handler: this.sort.bind(this, SORT_TEMPLATE),
                    group:0,
                    radioActive: this.state.sort.type === SORT_TEMPLATE,
                    // bgColor: this.state.sort.type === SORT_TEMPLATE ? "#dddddd": "#cccccc",
                    icon: `${GlobalConfig.StaticUrl}/img/SortAction_sm.svg`,
                    iconStyle: { width: '24px' },
                    subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
                }
            );
        }

        actions = actions.concat([
            {
                label: <span>{Strings['en'].project.actions.SORT_CREATED}</span>,
                value: Strings['en'].project.actions.SORT_CREATED,
                handler: this.sort.bind(this, SORT_CREATED),
                group:0,
                radioActive: this.state.sort.type === SORT_CREATED,
                //bgColor: this.state.sort.type === SORT_CREATED ? "#dddddd": "#cccccc",
                icon: `${GlobalConfig.StaticUrl}/img/SortAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            },
            {
                label: <span>{Strings['en'].project.actions.SORT_MODIFIED}</span>,
                value: Strings['en'].project.actions.SORT_MODIFIED,
                handler: this.sort.bind(this, SORT_MODIFIED),
                group:0,
                radioActive: this.state.sort.type === SORT_MODIFIED,
                // bgColor: this.state.sort.type === SORT_MODIFIED ? "#dddddd": "#cccccc",
                icon: `${GlobalConfig.StaticUrl}/img/SortAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },           
            }
        ]);


        if (
            PermissionsUtil.canEditProjectCollaborators(userChannelPermissions, userProjectPermissions)
            || PermissionsUtil.canViewProjectCollaborators(userChannelPermissions, userProjectPermissions)
        ) {

            const collbActionStr = PermissionsUtil.canEditProjectCollaborators(userChannelPermissions, userProjectPermissions) ? Strings['en'].project.actions.EDIT_PC : Strings['en'].project.actions.VIEW_PC;
            actions.push({
                value: collbActionStr,
                handler: this.gotoProjectCollabs,
                group: 0,
                //bgColor: '#cccccc',
                icon: `${GlobalConfig.StaticUrl}/img/Collaborator_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            });
        }

        if (PermissionsUtil.canRenameProject(userChannelPermissions, userProjectPermissions)) {
            actions.push({
                value: Strings['en'].project.actions.RENAME_P,
                handler: this._showModal.bind(this, 'renameProject'),
                group: 0,
                //bgColor: '#cccccc',
                icon: `${GlobalConfig.StaticUrl}/img/EditAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            });
        }

        if (PermissionsUtil.canDuplicateProject(userChannelPermissions)) {
            actions.push({
                value: Strings['en'].project.actions.COPY_P,
                handler: this._showModal.bind(this, 'copyProject'),
                group: 0,
                //bgColor: '#cccccc',
                icon: `${GlobalConfig.StaticUrl}/img/DuplicateAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            });
        }

        if (PermissionsUtil.canTransferProject(userChannelPermissions) && project.content_type) {
            actions.push({
                value: Strings['en'].project.actions.TRANSFER_P,
                handler: this._showModal.bind(this, 'transferProject'),
                group: 0,
                //bgColor: '#cccccc',
                icon: `${GlobalConfig.StaticUrl}/img/TransferAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            });
        }

        if (PermissionsUtil.canDeleteProject(userChannelPermissions, userProjectPermissions)) {
            actions.push({
                value: Strings['en'].project.actions.DELETE_P,
                handler: this._showModal.bind(this, 'confirmArchive'),
                group: 0,
                //bgColor: '#cccccc',
                icon: `${GlobalConfig.StaticUrl}/img/DeleteAction_sm.svg`,
                iconStyle: { width: '24px' },
                subNavIconStyle: { width: '24px', filter: 'invert(100%)' },
            });
        }

        if (
            PermissionsUtil.canManageProjectTags(userChannelPermissions, userProjectPermissions)
            && FeatureUtil.hasIntegrationTags(channelPermissions)
            && project.content_type === Globals.content_type.ACTIVITY
        ) {
            actions.push({
                value: Strings['en'].project.actions.MANAGE_P_ITAGS,
                handler: this._showModal.bind(this, 'projectTags'),
                group: 0,
                //bgColor: '#cccccc',
                iconClass: 'fa-tags',
            });
        }

        if (
            FeatureUtil.hasDetailedAnalytics(channelPermissions)
            && PermissionsUtil.viewDetailedProjectAnalytics(userChannelPermissions, userProjectPermissions)
            && project.content_type === Globals.content_type.ACTIVITY
        ) {
            actions.push({
                value: Strings['en'].project.actions.ANALYTICS,
                handler: this.gotoProjectAnalytics,
                group: 0,
                //bgColor: '#cccccc',
                iconClass: 'fa-bar-chart',
            });
        }

        return (
            <div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.match.params.channel, null, homeNavOptions)}
                />

                <div className="container main-container">
                    <SubNav
                        menuClasses="d-inline-block d-sm-none"
                        actions={actions}
                    >
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {projectName}
                            </div>
                            <div className="view-description">
                                <ProjectBreadCrumbs
                                    project={project}
                                    channel={channel}
                                    foldersFlat={foldersFlat}
                                />
                            </div>
                        </div>
                    </SubNav>

                    <Row className="mzl-cs-content main-content-nav">
                        <div className="col-12 col-sm-9 main-content">
                            {this.state.projectStoreState.error
                              || this.props.activityStoreState.error
                              || this.state.templateStoreState.error ?
                                <div>
                                    <ErrorBox error={this.state.templateStoreState.error} />
                                    <ErrorBox error={this.state.projectStoreState.error} />
                                    <ErrorBox error={this.props.activityStoreState.error} />
                                </div>
                                :
                                <div>
                                    <Row className="projectControls margin-top-md">
                                        <div className="col-12 col-md-6 margin-bottom-md">
                                            <div className="margin-bottom-sm">
                                                <label htmlFor="proj-description">{Strings['en'].project.PROJ_DESC}</label>
                                            </div>
                                            <ProjectDescriptionEditor
                                                inputId="proj-description"
                                                projectId={this.props.projectId}
                                                channelUserPermissions={userChannelPermissions}
                                                projectUserPermissions={userProjectPermissions}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 margin-bottom-md">
                                            <div>
                                                <FilterBox
                                                    className="margin-bottom-md"
                                                    inputId="act-name-filter"
                                                    inputClassName="projectFilterInput"
                                                    icon="fa fa-font"
                                                    label={Strings['en'].project.FILTER_BY_NAME}
                                                    onChange={this.onNameFilterChange}
                                                    value={this.state.nameFilter}
                                                />
                                            </div>
                                            {(showTagFilter) &&
                                                <div>
                                                    <FilterBox
                                                        className="margin-bottom-md"
                                                        inputId="act-tag-filter"
                                                        inputClassName="projectFilterInput"
                                                        icon="fa fa-tags"
                                                        label={Strings['en'].project.FILTER_BY_TAG}
                                                        onChange={this.onTagFilterChange}
                                                        value={this.state.tagFilter}
                                                    />
                                                </div>
                                            }
                                        </div>

                                        <div className="col-12 margin-bottom-sm">
                                            {numFilteredNodes} {numFilteredNodes !== 1 ? strNodePlural : strNodeSingular}
                                        </div>
                                    </Row>
                                    <ul className="list--topBorder">
                                        {contentNodes}
                                    </ul>
                                </div>
                            }
                        </div>
                        <SideNav className="d-none d-sm-block col-sm-3 mzl-cs-secondary-button-group" actions={actions} />
                    </Row>
                </div>

                {this.state.modalState['createCourse'] &&
                    <SingleInputModal
                        show
                        action={this.state.projectStoreState.initialized ? this.state.projectStoreState.action : {}}
                        childActionID={this.state.createShortCourseActionId}
                        headerText={Strings['en'].project.modals.NEW_SC_HEADER}
                        inputLabel={Strings['en'].project.modals.NEW_SC_INPUT_LABEL}
                        ariaLabel={Strings['en'].project.modals.NEW_SC_INPUT_LABEL}
                        buttonText={Strings['en'].project.modals.NEW_SC_BUTTON_TEXT}
                        defaultValue={Strings['en'].project.modals.NEW_SC_INPUT_DEFAULT}
                        closeHandler={this._hideModal.bind(this, 'createCourse')}
                        submitHandler={this.createCourseHandler}
                    />
                }
                
                {this.state.modalState["importCourse"] &&
                    <StackImportShortCourseModal
                        show
                        channelId={this.props.channelId}
                        projectId={this.props.projectId}
                        restrictToChannelId={this.props.match.params.channel}
                        closeHandler={this._hideModal.bind(this, 'importCourse')}
                        importStacks={this.state.importStacks}
                    />
                }
                

                {this.state.modalState['renameProject'] &&
                    <SingleInputModal
                        show
                        action={this.state.projectStoreState.initialized ? this.state.projectStoreState.action : {}}
                        childActionID={this.state.renameProjectActionId}
                        headerText={Strings['en'].project.modals.RENAME_HEADER}
                        inputLabel={Strings['en'].project.modals.RENAME_INPUT_LABEL}
                        ariaLabel={Strings['en'].project.modals.RENAME_INPUT_LABEL}
                        buttonText={Strings['en'].project.modals.RENAME_BUTTON_TEXT}
                        defaultValue={projectName}
                        closeHandler={this._hideModal.bind(this, 'renameProject')}
                        submitHandler={this.renameProjectHandler}
                    />
                }

                {this.state.modalState['confirmArchive'] &&
                    <ConfirmPhraseModal
                        closeHandler={this._hideModal.bind(this, 'confirmArchive')}
                        cancelHandler={this._hideModal.bind(this, 'confirmArchive')}
                        confirmButtonBsStyle="danger"
                        confirmPhrase={Strings['en'].project.modals.DELETE_CONFIRM_PHRASE}
                        confirmHandler={this.archiveProjectHandler}
                        cancelButtonText={Strings['en'].project.modals.DELETE_CANCEL_BUTTON_TEXT}
                        hasError={!!this.state.archiveProjectError}
                        message={!!this.state.archiveProjectError ? this.state.archiveProjectError.message : ''}
                    >
                        <div className="margin-bottom-lg">
                                {(project.content_type === Globals.content_type.ACTIVITY) &&
                                    <p>
                                        {Strings['en'].project.modals.DELETE_WARNING_ACT}
                                    </p>
                                }
                                {(project.content_type === Globals.content_type.COURSE) &&
                                    <p>
                                        {Strings['en'].project.modals.DELETE_WARNING_SC}
                                    </p>
                                }
                        </div>
                    </ConfirmPhraseModal>
                }

                {this.state.modalState['copyProject'] &&
                    <CopyProjectModal
                        show
                        project={project}
                        disabled={!!this.state.copyProjectActionId}
                        distributionRestrictedActivities={filter(this.props.activityStoreState.activities, act => act.meta_data && act.meta_data.distributionRestricted)}
                        error={this.state.copyProjectError}
                        closeHandler={this._hideModal.bind(this, 'copyProject')}
                        submitHandler={this.copyProjHandler}
                        
                    />
                }

                {this.state.modalState['transferProject'] &&
                    <TransferProjectModal
                        show
                        project={project}
                        disabled={!!this.state.transferProjectActionId}
                        distributionRestrictedActivities={filter(this.props.activityStoreState.activities, act => act.meta_data && act.meta_data.distributionRestricted)}
                        error={this.state.transferProjectError}
                        closeHandler={this._hideModal.bind(this, 'transferProject')}
                        submitHandler={this.transferProjectHandler}
                    />
                }

                {this.state.modalState['projectTags'] &&
                    <ManageProjectTagsModal
                        show
                        projectId={this.props.match.params.projectID}
                        closeHandler={this._hideModal.bind(this, 'projectTags')}
                        orgId={parseInt(this.props.match.params.channel)}
                    />
                }

                {this.state.modalState["stackImport"] &&
                    <StackImportModal
                        show
                        projectId={this.props.match.params.projectID}
                        closeHandler={this._hideModal.bind(this, 'stackImport')}
                        importStacks={this.state.importStacks}
                    />
                }

                {this.state.modalState["stackProjectImport"] &&
                    <StackImportProjectModal
                        show
                        projectId={this.props.match.params.projectID}
                        channelId={this.props.match.params.channel}
                        closeHandler={this._hideModal.bind(this, 'stackProjectImport')}
                        importStacks={this.state.importStacks}
                    />
                }

            </div>
        );
    }
}

ProjectView.propTypes = propTypes;
ProjectView.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithProjectActivities(WithProjectShortCourses(WithOrganizationIntegrationTags(ProjectView))));

// WithProjectActivities is expected the projectId, channelId props. "Rename" props.params.projectID to props.projectId and props.params.channel to props.channelId here
function WrappedComponentWithUpdatedPropNames(props) {
    return <WrappedComponent {...props} projectId={props.match.params.projectID} channelId={props.match.params.channel} orgId={props.match.params.channel} renderBeforeLodingTags />;
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({ channel: PropTypes.string.isRequired, projectID: PropTypes.string.isRequired }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;